import Box from "@mui/material/Box";
import { createContext, useState } from "react";
import { Setter } from "../_/utils/ReactUtils";
import { LocationContext } from "../_/contexts/LinkContext";


type Props = {
  children: React.ReactNode;
}


export const Template = ({ children }: Props) => {
const [link, setLink] = useState<string | null>("dupka")

  return (
    <LocationContext.Provider value={{link, setLink}}>
      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </LocationContext.Provider>
  );
}
